<template>
  <div>
    <h1>
      <div class="spinner-border text-secondary loader" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </h1>
    <div
      class="mainBlockFullSize"
      :class="{ mainBlockNotFullSize: selectedUser }"
    >
      <router-link
        class="mr-3"
        style="margin-right: 20px"
        v-for="route in routes"
        :to="route.to"
        :key="route.to"
      >
        <div
          class="headerBlock text-center"
          :class="{ headerBorder: route.to === currentRoute }"
          v-if="route.roles.includes(role)"
        >
          {{ route.name }}
        </div>
      </router-link>
      <div
        data-toggle="modal"
        style="cursor: pointer"
        data-target="#changePasswordModal"
        class="mr-3 headerBlock"
      >
        Zmiana hasła
      </div>

      <router-link
        to="/settings/add-admin"
        v-if="role === 'ADMIN' || role === 'ADMIN1'"
      >
        <div
          class="headerBlock text-center"
          :class="{ headerBorder: currentRoute === '/settings/add-admin' }"
        >
          Dodaj konto
        </div>
      </router-link>

      <router-link
        to="/settings/modals"
        v-if="role === 'ADMIN' || role === 'ADMIN1' || role === 'ADMIN2'"
      >
        <div
          class="headerBlock text-center"
          :class="{ headerBorder: currentRoute === '/settings/modals' }"
        >
          Modale
        </div>
      </router-link>

      <router-link
        to="/settings/news"
        v-if="role === 'ADMIN' || role === 'ADMIN1' || role === 'ADMIN2'"
      >
        <div
          class="headerBlock text-center"
          :class="{ headerBorder: currentRoute === '/settings/news' }"
        >
          Aktualności
        </div>
      </router-link>
      <router-link
        to="/settings/accounting-notes-descriptions"
        v-if="role === 'ADMIN' || role === 'ADMIN1' || role === 'ADMIN2'"
      >
        <div
          class="headerBlock text-center"
          :class="{
            headerBorder:
              currentRoute === '/settings/accounting-notes-descriptions',
          }"
        >
          Opisy not księgowych
        </div>
      </router-link>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "settings",
  computed: {
    role() {
      return this.$store.getters.getUserRole;
    },
    selectedUser() {
      return this.$store.getters.getSelectedUser;
    },
  },
  watch: {
    $route() {
      this.currentRoute = this.$route.path;
    },
  },
  data: function () {
    return {
      currentRoute: this.$route.path,
      routes: [
        {
          to: "/settings/services-order",
          name: "Kolejność wyświetlania kategorii",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/services",
          name: "Lista usług",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/servicesCategories",
          name: "Lista kategorii usług",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/create-service",
          name: "Dodaj usługę",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/create-sub-category",
          name: "Podkategorie",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/long-distance-services",
          name: "Usługi niestandardowe",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        // {
        //   to: "/settings/notifications-list",
        //   name: "Lista powiadomień admina",
        // },
        {
          to: "/settings/push-notifications",
          name: "Wyślij powiadomienie",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/send-message",
          name: "Wiadomość do użytkowników",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/parameters",
          name: "Lista parametrów",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/send-email",
          name: "Wyślij email",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/user-commisions",
          name: "Prowizje użytkowników",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/settings/reports",
          name: "Raporty",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/settings/users-with-service",
          name: "Użytkownicy w wybranym mieście",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/settings/promotions",
          name: "Promocje",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/settings/generate-sql",
          name: "Generowanie SQL",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
      ],
    };
  },
};
</script>

<style scoped>
button.btn {
  margin-left: 20px;
}
.headerBlock {
  height: 75px;
  display: block;
  text-align: end;
  color: #090741;
  position: relative;
  display: flex;
  align-items: center;
}
.headerBorder {
  font-weight: bold;
  border-bottom: 3px solid #f2b989;
}
a {
  text-decoration: none;
  margin-right: 20px;
}

.mainBlockFullSize {
  width: 99%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-items: center;
  padding-top: 3%;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.mainBlockNotFullSize {
  width: 80%;
}
</style>
